import React from 'react';
export function CostComparisonSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 border-t border-white/10" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-134">
          ¿Cuánto cuesta realmente{' '}
          <span className="text-[#00E68A]" data-id="element-135">NO tenerlo?</span>
        </h2>

        <div className="bg-black border border-white/10 rounded-2xl overflow-hidden shadow-xl" data-id="element-136">
          <div className="overflow-x-auto" data-id="element-137">
            <table className="w-full text-sm sm:text-base text-left" data-id="element-138">
              <thead className="bg-white/5 border-b border-white/10" data-id="element-139">
                <tr data-id="element-140">
                  <th className="px-4 sm:px-8 py-5 font-bold text-gray-300 w-1/2" data-id="element-141">
                    Lo que hacés sin PROFEPACK
                  </th>
                  <th className="px-4 sm:px-8 py-5 font-black text-[#00E68A] w-1/2" data-id="element-142">
                    El costo real
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5" data-id="element-143">
                <tr className="hover:bg-white/5 transition-colors" data-id="element-144">
                  <td className="px-4 sm:px-8 py-5 text-gray-400" data-id="element-145">
                    3 horas de búsqueda de material por semana × 40 semanas
                  </td>
                  <td className="px-4 sm:px-8 py-5 text-white font-bold" data-id="element-146">
                    <span className="text-[#FF0000] mr-2" data-id="element-147">⚠️</span> 120 horas de
                    tu vida por año
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-148">
                  <td className="px-4 sm:px-8 py-5 text-gray-400" data-id="element-149">
                    Evaluaciones sin solucionario × 30 alumnos × 3 trimestres
                  </td>
                  <td className="px-4 sm:px-8 py-5 text-white font-bold" data-id="element-150">
                    <span className="text-[#FF0000] mr-2" data-id="element-151">⚠️</span> Sábados de
                    corrección sin criterios claros
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-152">
                  <td className="px-4 sm:px-8 py-5 text-gray-400" data-id="element-153">
                    Material adaptado para alumnos con dificultades inventado en
                    el momento
                  </td>
                  <td className="px-4 sm:px-8 py-5 text-white font-bold" data-id="element-154">
                    <span className="text-[#FF0000] mr-2" data-id="element-155">⚠️</span> Riesgo
                    pedagógico + desgaste docente
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-156">
                  <td className="px-4 sm:px-8 py-5 text-gray-400" data-id="element-157">
                    Análisis literario sin secuencia didáctica clara
                  </td>
                  <td className="px-4 sm:px-8 py-5 text-white font-bold" data-id="element-158">
                    <span className="text-[#FF0000] mr-2" data-id="element-159">⚠️</span> Alumnos que
                    no comprenden y docente que improvisa
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-160">
                  <td className="px-4 sm:px-8 py-5 text-gray-400" data-id="element-161">
                    Grupos con niveles distintos sin sistema de diferenciación
                  </td>
                  <td className="px-4 sm:px-8 py-5 text-white font-bold" data-id="element-162">
                    <span className="text-[#FF0000] mr-2" data-id="element-163">⚠️</span> Alumnos que
                    se pierden y no vuelven a enganchar
                  </td>
                </tr>
                <tr className="hover:bg-white/5 transition-colors" data-id="element-164">
                  <td className="px-4 sm:px-8 py-5 text-gray-400" data-id="element-165">
                    Planificación para directivos a último momento
                  </td>
                  <td className="px-4 sm:px-8 py-5 text-white font-bold" data-id="element-166">
                    <span className="text-[#FF0000] mr-2" data-id="element-167">⚠️</span> Noches de
                    domingo que podrías estar descansando
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}